const TRY_MAX_NUM = 4;
const IS_JUMP_TO_UUAP_KEY = 'jumpToUUapNum';
const EXPIRED_TIME = 5 * 60 * 1000;

const getJumpInfoFromSession = () => {
    try {
        const data = sessionStorage.getItem(IS_JUMP_TO_UUAP_KEY) || '0,0';
        const [num, timestamp] = data?.split(',');
        return {
            num: parseInt(num || '', 10) || 0,
            timestamp: parseInt(timestamp || '', 10) || 0,
        };
    } catch {
        return {
            num: 0,
            timestamp: 0,
        };
    }
};

/**
 * 判断uuap是否频繁跳转
*/
export const isUuapJumpToMuch = () => {
    const {num} = getJumpInfoFromSession();
    return num >= TRY_MAX_NUM;
};

export const clearUuapJumpNum = () => {
    try {
        sessionStorage.removeItem(IS_JUMP_TO_UUAP_KEY);
    } catch {
        return 0;
    }
};

export const addUuapJumpNum = () => {
    const {num, timestamp} = getJumpInfoFromSession();
    try {
        const isExpired = (+new Date() - timestamp) > EXPIRED_TIME;
        if (isExpired) {
            sessionStorage.setItem(IS_JUMP_TO_UUAP_KEY, `1,${+new Date()}`);
        } else {
            sessionStorage.setItem(IS_JUMP_TO_UUAP_KEY, `${num + 1},${+new Date()}`);
        }
    } catch (error) {
        console.error(error);
    }
};


